import { ReactNode, useCallback, useState } from 'react';
import { ABTestDrawdownControls, ABTestProps } from '~/types';
import { ABTestContext } from './ABTestContext';

export const AB_TEST_KEY = 'AB_TEST';

export const defaultABTestProps: ABTestProps = {
    drawdownControl: ABTestDrawdownControls.AGE,
};

export const ABTestProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const sessionProps = JSON.parse(sessionStorage.getItem(AB_TEST_KEY) || '{}');

    const [state, setState] = useState<ABTestProps>({ ...defaultABTestProps, ...sessionProps });

    const updateABTestState = useCallback(
        (props: ABTestProps) => {
            const newState = { ...state, ...props };
            sessionStorage.setItem(AB_TEST_KEY, JSON.stringify(newState));
            setState(newState);
        },
        [setState, state]
    );

    return <ABTestContext.Provider value={{ ...state, updateABTestState }}>{children}</ABTestContext.Provider>;
};
